import { Purchases, ErrorCode, PurchasesError } from "@revenuecat/purchases-js";

let configured = false;

/**
 * Configure the RevenueCat Web SDK.
 * Safe to call multiple times — subsequent calls are no-ops.
 */
export function configureRevenueCat(
  apiKey: string,
  appUserId: string,
): Purchases {
  if (!configured) {
    Purchases.configure({ apiKey, appUserId });
    configured = true;
  }
  return Purchases.getSharedInstance();
}

export { ErrorCode, PurchasesError };
